import React from 'react';
import SIcon from './SIcon';
import { faArrowCircleDown } from '@fortawesome/pro-solid-svg-icons';

const Icon = props => <SIcon {...props} icon={faArrowCircleDown} fa />;

export default Icon;
